<template>
    <layout-theme>
        <div class="container mt-5">
            <div class="column is-12 is-centered survey-box">
                <h1>
                    Pesquisa de Satisfação
                    <span v-if="group">
                        <br />
                        {{ group.course.name }} / {{ group.code }}
                    </span>
                </h1>

                <div v-if="survey">
                    <h2>{{ survey.name }}</h2>

                    <b-field v-for="question in survey.questions" :key="question.id" :label="question.text" class="block">
                        <div v-for="alternative in question.alternatives" :key="alternative.id" >
                            <b-input v-if="question.type == 'DISCURSIVE'" 
                                value=""
                                :name="`questions[${question.id}][answer][discursive_answer][${alternative.id}]`"
                                v-model="answers[question.id]['answer']['discursive_answer'][alternative.id]"
                            />

                            <div v-if="question.type == 'MULTIPLE-ONE'">
                                <b-radio
                                    :name="`questions[${question.id}][answer][alternative_id][]`"
                                    :native-value="alternative.id"
                                    v-model="answers[question.id]['answer']['alternative_id']"
                                    @input="answers = Object.assign({}, answers)"
                                >
                                    {{ alternative.text }}
                                </b-radio>
                                <b-input v-if="alternative.justifiable"
                                    v-show="answers[question.id]['answer']['alternative_id'] == alternative.id"
                                    placeholder="Justique"
                                    value=""
                                    :name="`questions[${question.id}][answer][discursive_answer][${alternative.id}]`"
                                    v-model="answers[question.id]['answer']['discursive_answer'][alternative.id]"
                                />
                            </div>

                            <div v-if="question.type == 'MULTIPLE-MULTIPLE'">
                                <b-checkbox
                                    :name="`questions[${question.id}][answer][alternative_id][]`"
                                    :native-value="alternative.id"
                                    v-model="answers[question.id]['answer']['alternative_id']"
                                    @input="answers = Object.assign({}, answers)"
                                >
                                    {{ alternative.text }}
                                </b-checkbox>
                                <b-input v-if="alternative.justifiable"
                                    v-show="answers[question.id]['answer']['alternative_id'].includes(alternative.id)"
                                    placeholder="Justique"
                                    value=""
                                    :name="`questions[${question.id}][answer][discursive_answer][${alternative.id}]`"
                                    v-model="answers[question.id]['answer']['discursive_answer'][alternative.id]"
                                />
                            </div>
                        </div>
                    </b-field>

                    <b-field class="pt-5">
                        <b-button
                            :disabled="sending"
                            icon-left="save"
                            label="Enviar"
                            type="is-success"
                            @click="send"
                        />
                    </b-field>
                </div>
            </div>
        </div>
    </layout-theme>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import api from '@/api.js'
import LayoutTheme from '@/components/LayoutTheme.vue'

const NEXT = '/end'

export default {
    components: {
        LayoutTheme,
    },

    data() {
        return {
            survey: null,
            answers: {},
            group: null,
            sending: false,
        }
    },

    watch: {
        survey: function() {
            this.setupAnswers()
        }
    },

    beforeMount() {
        this.setupAnswers()
    },

    mounted() {
        api.userRequest({
            url: `user/me/satisfaction-survey-to-answer`,
            method: 'get',
        }).then(data => {
            if (data 
                && data.group 
                && data.group.satisfaction_survey 
                && data.group.satisfaction_survey.survey 
                && data.group.satisfaction_survey.survey.id
            ) {
                this.group = data.group
                this.survey = data.group.satisfaction_survey.survey
            } else {
                console.log('Nenhuma pesquisa de satisfação encontrada para ser respondida')
                this.$router.push(NEXT)
            }
        }).catch(e => {
            console.log('Erro ao obter pesquisa de satisfação', e.message)
            this.$router.push(NEXT)
        })
    },

    methods: {
        setupAnswers() {
            if (this.survey && this.survey.questions) {
                this.survey.questions.forEach(question => {
                    question.alternatives.forEach(alternative => {
                        if (question.type == 'DISCURSIVE') {
                            _.setWith(this.answers, `[${question.id}]['answer']['discursive_answer']["${alternative.id}"]`, '', Object)
                            
                        } else if (question.type == 'MULTIPLE-MULTIPLE') {
                            _.setWith(this.answers, `[${question.id}]['answer']['alternative_id']`, [], Object)

                        } else {
                            _.setWith(this.answers, `[${question.id}]['answer']['alternative_id']`, '', Object)
                        }

                        if (alternative.justifiable) {
                            _.setWith(this.answers, `[${question.id}]['answer']['discursive_answer']['${alternative.id}']`, '', Object)
                        }
                    })
                })
            }
        },

        validate() {
            let validationFail = false
            Object.keys(this.answers).every(questionId => {
                let question = this.answers[questionId]
                if ('alternative_id' in question.answer 
                    && !question.answer.alternative_id
                    || (Array.isArray(question.answer.alternative_id) && question.answer.alternative_id.length == 0)
                ) {
                    validationFail = true
                    this.$buefy.toast.open({
                        duration: 4000,
                        message: 'Existem perguntas sem nenhuma opção selecionada! Por favor, responda a todas as perguntas.',
                        type: 'is-danger'
                    })
                    return false
                }

                if (!('alternative_id' in question.answer) && 'discursive_answer' in question.answer) {
                    let discursives = 0
                    _.forEach(question.answer.discursive_answer, alternative => {
                        if (!alternative) {
                            discursives++
                        }
                    })
                    if (discursives > 0) {
                        validationFail = true
                        this.$buefy.toast.open({
                            duration: 4000,
                            message: 'Existem perguntas em branco! Por favor, responda a todas as perguntas.',
                            type: 'is-danger'
                        })
                        return false
                    }
                }

                if ('alternative_id' in question.answer 
                    && 'discursive_answer' in question.answer
                    && question.answer.alternative_id in question.answer.discursive_answer
                ) {
                    if (!question.answer.discursive_answer[question.answer.alternative_id]) {
                        validationFail = true
                        this.$buefy.toast.open({
                            duration: 4000,
                            message: 'Existem justificativas em branco! Por favor, preencha todas as justificativas.',
                            type: 'is-danger'
                        })
                        return false
                    }
                }

                return true
            })

            return !validationFail
        },

        send() {
            if (this.validate()) {
                const loading = this.$buefy.loading.open()
                this.sending = true

                api.appRequest({
                    url: `survey/${this.survey.id}/interview`,
                    method: 'post',
                    data: {
                        questions: this.answers,
                        unit_id: this.unit.id,
                        location_id: 1, // 1=Atualização cadastral (interno)
                        login: this.user.username,
                        group_id: this.group.id,
                    },
                }).then(() => {
                    this.$router.push(NEXT)
                }).catch(e => {
                    let message = 'Erro ao salvar respostas da pesquisa de satisfação'

                    if (e.message) {
                        message = e.message
                    }

                    if (e.response && e.response.data && e.response.data.exception) {
                        const exception = e.response.data.exception

                        if (exception.message) {
                            message = `<p>${exception.message}</p>`
                        }

                        switch (exception.type) {
                            case 'ValidationException':
                                if (exception.details) {
                                    message += Object.values(exception.details)[0][0]
                                    this.errors = exception.details
                                } else {
                                    message += exception.message ? exception.message : exception.type
                                }
                                break

                            case 'SurveyUserAnsweredException':
                                this.$router.push(NEXT)
                                break

                            default:
                                message += exception.message ? exception.message : exception.type
                                break;
                        }
                    }

                    this.$buefy.toast.open({
                        duration: 5000,
                        message: message,
                        position: 'is-bottom',
                        type: 'is-danger'
                    })
                }).finally(() => {
                    this.sending = false
                    loading.close()
                })
            } else {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: 'Responda a todas as questões.',
                    position: 'is-bottom',
                    type: 'is-danger'
                })
            }
        },
    },

    computed: {
        ...mapGetters({
            user: 'getUser',
            equipment: 'getEquipment',
            unit: 'getUnit',
        })
    }
}
</script>